export default "__VITE_ASSET__CaOfQ79D__"